import { render, staticRenderFns } from "./staffs-results-edit.vue?vue&type=template&id=a442964a&"
import script from "./staffs-results-edit.vue?vue&type=script&lang=js&"
export * from "./staffs-results-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports